import { atom, selector } from 'recoil';
import {
  Devices,
  GetModelListDtoRx,
  GetFacilitiesDtoRx,
  GetDetailDeviceDtoRx,
  SensorDataDtoRx,
  OriginalDataDtoRx,
  ChangeHistoryDtoRx,
  EventsDtoRx,
  CommandDtoRx,
} from '@/sdk/data-contracts';

export const deviceListRecoil = atom<Devices[]>({
  key: 'deviceListRecoil',
  default: [],
});

export const deviceDetailRecoil = atom<GetDetailDeviceDtoRx | null>({
  key: 'deviceDetailRecoil',
  default: null,
});

export const deviceModelListRecoil = atom<string[]>({
  key: 'deviceModelListRecoil',
  default: [],
});

export const deviceSiteListRecoil = atom<string[]>({
  key: 'deviceSiteListRecoil',
  default: [],
});

export const deviceAddModelListRecoil = atom<GetModelListDtoRx[]>({
  key: 'deviceAddModelListRecoil',
  default: [],
});

export const deviceAddFacilitiesRecoil = atom<GetFacilitiesDtoRx | null>({
  key: 'deviceAddFacilitiesRecoil',
  default: null,
});

export const deviceSensorDataListRecoil = atom<SensorDataDtoRx[]>({
  key: 'deviceSensorDataListRecoil',
  default: [],
});

export const deviceTextDataListRecoil = atom<OriginalDataDtoRx[]>({
  key: 'deviceTextDataListRecoil',
  default: [],
});

export const deviceSettingChangeHistoryListRecoil = atom<ChangeHistoryDtoRx[]>({
  key: 'deviceSettingChangeHistoryListRecoil',
  default: [],
});

export const deviceEventSettingListRecoil = atom<EventsDtoRx[]>({
  key: 'deviceEventSettingListRecoil',
  default: [],
});

export const deviceDataGraphListRecoil = atom<[]>({
  key: 'deviceDataGraphListRecoil',
  default: [],
});

export const deviceDeviceCommandListRecoil = atom<CommandDtoRx[]>({
  key: 'deviceDeviceCommandListRecoil',
  default: [],
});

export interface deviceSelectFacilityProps {
  facilityName: string;
  facilityAddress: string;
  latitude: string;
  longitude: string;
}

export const deviceSelectFacilityRecoil =
  atom<deviceSelectFacilityProps | null>({
    key: 'deviceSelectFacilityRecoil',
    default: null,
  });

// export const deviceDetailRecoil = atom<GetDetailModelDtoRx | null>({
//   key: 'deviceDetailRecoil',
//   default: null,
// });

// export const deviceReportRecoil = atom<GetModelReportDtoRx[]>({
//   key: 'deviceReportRecoil',
//   default: [],
// });
